export default {
  title: 'Nuevo Usuario',
  save: 'Guardar',
  create: 'Crear',
  firstName: 'Nombre',
  lastName: 'Apellido',
  email: 'Correo electrónico',
  repeatEmail: 'Repetir correo electrónico',
  setPasswordManually: 'Establecer contraseña manualmente (no se enviará correo al usuario)',
  password: 'Contraseña',
  repeatPassword: 'Repetir contraseña',
  phoneNumber: 'Número de teléfono (si está presente requerirá 2FA)',
  domain: 'Dominio',
  true: 'Verdadero',
  false: 'Falso',
  firstNameRequired: 'El nombre es obligatorio',
  lastNameRequired: 'El apellido es obligatorio',
  emailRequired: 'El correo electrónico es obligatorio',
  emailInvalid: 'El correo electrónico debe ser válido',
  emailExists: 'El correo electrónico ya existe',
  emailsMustMatch: 'Los correos electrónicos deben coincidir',
  passwordRequirements: 'La contraseña debe tener más de 12 caracteres y debe contener caracteres numéricos, minúsculas, mayúsculas y caracteres especiales (#, ?, !, @, $, %, ^, *, -)',
  passwordsMustMatch: 'Las contraseñas deben coincidir',
  phoneNumberInvalid: 'El número de teléfono debe comenzar con el código de país +X'
}
